import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { MAuswahlwert } from "../../../metamodell";

export interface ITorMenuTeil {
  auswahlwert: MAuswahlwert;
  disabled: boolean;
  setSelected?: (s: unknown) => void;
}

export function TorMenuTeil({ auswahlwert, disabled }: ITorMenuTeil) {
  const { Key, Name, Auswahlbild } = auswahlwert;
  let { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: Key,
    data: auswahlwert,
  });
  if (disabled) {
    listeners = {};
  }

  return (
    <button
      ref={setNodeRef}
      id={Key}
      data-button-key={Name}
      title={
        disabled ? I18N("In gewählter Serie nicht verfügbar") : I18N("aria::Tor hinzufügen:") + Name
      }
      aria-label={
        disabled
          ? Name.concat(" ", I18N("aria::(nicht verfügbar)"))
          : I18N("aria::Tor hinzufügen:") + Name
      }
      aria-disabled={disabled}
      className={`torMenuTeil ${disabled ? "disabled" : ""}`}
      {...listeners}
      {...attributes}
    >
      <div
        className="image"
        style={{ backgroundImage: `url(${Auswahlbild})` }}
        role="img"
        aria-label={Name}
      />
      <div className="label">{Name}</div>
    </button>
  );
}
